<template>
  <transition-group name="p-act__ivList" tag="ul" v-if="max > 0">
  <li v-for="(entry, i) in params" :key="i">
    <a class="c-linkEntry" :href="entry.url">
      <div class="c-linkEntry__photo">
        <img :src="entry.img" alt="" width="200" height="160" />
        <span v-if="entry.new" class="c-linkEntry__photo__new c-iconNew"></span>
      </div>
      <div class="c-linkEntry__info">
        <ul class="c-linkEntry__info__date">
          <li><div class="c-label">{{entry.label}}</div></li>
          <li><div>{{entry.date}}</div></li>
        </ul>
        <p v-html="entry.title"></p>
        <span v-if="entry.name" v-html="entry.name"></span>
      </div>
    </a>
  </li>
  </transition-group>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    props: ['step'],
    data() {
      return {
        assets_path: assets_path,
        params: [],
        data: [],
        max: 0,
        count: 0,
        //step: 10,
        isFinish: false
      }
    },
    store,
    mounted() {
      this.data = JSON.parse(document.getElementById(`js-param-interview`).textContent);
      this.max = this.data.length;

      if (this.max === 0) {
        this.isFinish = true;
        this.$parent.finishMore('interview');
      } else {
        if (!this.step) {
          this.step = 2;
        }
      }
    },
    methods: {
      add() {
        const arr = this.data.splice(0, this.step);
        const start = this.params.length;
        const step = Math.min(arr.length, this.step);

        for (let i = 0; i < step; i++) {
          this.$set(this.params, start + i, arr[i]);
        }

        if (this.data.length === 0) {
          this.isFinish = true;
          this.$parent.finishMore('interview');
        }
      },
      more() {
        if (this.isFinish) return;
        this.add();
      }
    }
  }
</script>
